import React, {useState} from 'react';
import Select from 'react-select';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const CouplingContainerSummit = ({toggleVisibilityCoupling, isVisibleCoupling, 
        handleChangeCoupling, selectedCoupling, couplingData, commentCoupling, commentTextAreaRefCoupling,
        handleCommentChangeCoupling, toggleCouplingMarker, couplingMarker, couplingSave, rankComponentData, 
        handleChangeRankComponentCoupling, selectedRankCouling}) => {

  const [showTooltip, setShowTooltip] = useState(false);        
            
  return (
    <React.Fragment>
      <button onClick={toggleVisibilityCoupling} className={isVisibleCoupling ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisibleCoupling ? 'Муфта: скрыть' : 'Муфта: показать'}
      </button>
      {isVisibleCoupling && (
        <div className='divСommunicationsDrawer'>

          {selectedRankCouling === '1' || selectedRankCouling === '2' ? (
             <img src='./сoupling.png' width='30' height='30' style={{ marginRight: "5px" }} />
               ) : (
             <img src='./coupling_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}

          <label className='textTitleDrawer'>Муфта</label>
          <hr className="horizontalLineDrawer"/>

          <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeCoupling} value={selectedCoupling}>
              <option value="null">Выберите муфту</option>
              {couplingData.map(coupling => (
                <option key={coupling.id} value={coupling.id}>{coupling.name}</option>
              ))}
            </select>

             <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeRankComponentCoupling} value={selectedRankCouling}>
              <option value="null">Линк высшего узла</option>
              {rankComponentData.map(rank => (
                <option key={rank.id} value={rank.id}>{rank.name}</option>
              ))}
            </select>

            <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <NewReleasesIcon
                  style={{
                    cursor: "pointer",
                    color: "#ebb434",
                    fontSize: "24px",
                    marginLeft: "5px",
                  }}
                />
                {showTooltip && (
                  <div className='tooltipWarning' >
                    Выберите максимальный ранг линка,<br/>
                    который присутствует в муфте.
                  </div>
                )}
              </div>
              
          <hr className="horizontalLineDrawer"/>

          <div>

          </div>
          <div>
            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentCoupling}
              ref={commentTextAreaRefCoupling}
              onChange={handleCommentChangeCoupling}
            />
            <button onClick={toggleCouplingMarker} className={couplingMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {couplingMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={couplingSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CouplingContainerSummit;